import { jsx as _jsx } from "react/jsx-runtime";
import { useTextTelegram } from '../../hooks/useTextTelegram';
import s from './main-title.module.scss';
export const MainTitle = ({ title, isTg }) => {
    const telegramText = useTextTelegram(isTg);
    return (_jsx("div", { className: s.mainTitle, children: _jsx("h1", { style: telegramText, children: title }) }));
};
